import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';

export default function Navbar() {
  const { token, username, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/dash');

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <nav style={{
      background: '#050810',
      borderBottom: '1px solid rgba(43,127,255,0.1)',
      padding: '0 32px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <Logo size={34} />
      </Link>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        {!isAdmin && (
          <>
            <Link to="/find" className="nav-link" style={{ fontSize: '12px' }}>Find a Pro</Link>
            <Link to="/barber" className="btn btn-primary" style={{ padding: '9px 20px', fontSize: '12px' }}>
              Book Now
            </Link>
          </>
        )}
        {token && isAdmin && (
          <>
            <span className="hide-mobile" style={{ color: '#555', fontSize: '12px', letterSpacing: '0.04em' }}>
              {username}
            </span>
            <Link to="/dash" className="nav-link" style={{ fontSize: '12px' }}>Dashboard</Link>
            <button
              onClick={handleLogout}
              className="btn btn-ghost"
              style={{ fontSize: '12px', padding: '6px 12px' }}
            >
              Logout
            </button>
          </>
        )}
        {!token && !isAdmin && (
          <a href="/dash/login" className="nav-link">Admin</a>
        )}
      </div>
    </nav>
  );
}
